import { EngineStoreData } from "@/stores/EngineStore/EngineStore.ts";
import { AppPage } from "@/stores/EngineStore/enums/AppPage.ts";

export const removeCartItemHelper = (state: EngineStoreData, idToRemove: string) => {
  const newCartAccommodationItems = state.cartAccommodationItems.filter((item) => item.id !== idToRemove);

  // if cart is empty, go back to accommodation picking
  if (newCartAccommodationItems.length === 0) {
    setTimeout(() => state.setPage(AppPage.AccommodationPicking), 0);
  }

  return {
    ...state,
    cartAccommodationItems: newCartAccommodationItems,
  };
};
